import { TableProps } from '@aibees/shared/components';
import { PaginationResponse } from '@aibees/shared/definition';

export interface AdvancedTableSelectPopupProps<T> {
  className?: string;
  table?: TableProps;
  data?: PaginationResponse<T>;
  additionalContent?: React.ReactNode;
}

export enum SelectionMode {
  PAGE = 'PAGE',
  ALL = 'ALL',
  NUMBER = 'NUMBER',
}

export interface ExportSizeLimit {
  systemLimitReached: boolean;
  normalRowsLimit: number;
  totalRowsLimit: number;
  systemLimit: number;
}
